import { Image } from "@/components/common/Image"
import { cn, moneyFormat } from "@/utils"
import { IBAN, ICard, maskCardNumber } from "@usher/pe-client-front-end-lib"
import { FormattedMessage } from "react-intl"
import { Link, useHistory } from "react-router-dom"
import { Fragment } from "react/jsx-runtime"

export const SidebarCards = ({ cards, fetching, msg }: { cards: (ICard | IBAN)[]; fetching: boolean; msg?: string }) => {
  const history = useHistory()
  let message = ""
  if (fetching) message = "Loading..."
  else if (cards.length === 0) message = "No active cards yet."
  if (message !== "")
    return (
      <div className="account-sidebar_cards-item">
        <FormattedMessage id={msg ?? "no-active-cards"} />
      </div>
    )
  return (
    <>
      {cards?.map((card, key) => {
        const isIban = "account_number" in card
        return <CardItem withAdd={key === 0} onClick={isIban ? void 0 : () => history.push(`/cards/${card.id}`)} card={card} key={key} />
      })}
    </>
  )
}

const CardItem = ({ withAdd, card, onClick }: { withAdd?: boolean; card: IBAN | ICard; onClick?: VoidFunction }) => {
  const isCard = !("account_number" in card)
  const name = isCard ? card.card_name || card.cardName || "N/A" : `${card.title ?? "IBAN"} (${card.currency})`
  return (
    <Fragment>
      <div className="account-sidebar_cards-title flex items-center justify-between w-full mt-3">
        <div className="flex items-center gap-2">
          <FormattedMessage id={isCard ? "card_balance" : "iban_balance"} />{" "}
          <span
            className={cn(Number(card.balance) < 0 ? "text-red-500" : "text-green-500")}
          >{`${moneyFormat(Number(card.balance))} ${card.currency}`}</span>
        </div>
        {withAdd && isCard && (
          <Link to="/cards/create" className="account-sidebar_cards-add">
            <Image src="plus.svg" />
          </Link>
        )}
      </div>
      <div className="account-sidebar_cards-item">
        <div className="account-sidebar_cards-name" onClick={onClick}>
          <Image src={isCard ? "cards-img.svg" : "iban-bank.svg"} /> <span style={{ display: "inline" }}>{name}</span>
          <span className="hover:text-main-main cursor-pointer">{isCard ? maskCardNumber(card.card_pan) : card.account_number}</span>
        </div>
      </div>
    </Fragment>
  )
}
